import type { FileUploadRequest } from "../web-api";

export const mapFilesToRequests = (
  files: FileList,
  organizationSlug: string,
): Promise<FileUploadRequest[]> => {
  const promises = [];
  for (let i = 0; i < files.length; i++) {
    promises.push(mapFileToRequest(files[i], organizationSlug));
  }
  return Promise.all(promises);
};

export const mapFileToRequest = (
  file: File,
  organizationSlug: string,
): Promise<FileUploadRequest> => {
  return new Promise<FileUploadRequest>((resolve) => {
    const fileReader = new FileReader();
    fileReader.onload = (e) => {
      const dataUri = e.target!.result as string;
      const encodedContent = dataUri.split(",")[1];
      resolve({
        type: file.type,
        name: file.name,
        data: encodedContent,
        organizationSlug,
      });
    };
    fileReader.readAsDataURL(file);
  });
};
